import { render, staticRenderFns } from "./AddLabourerAttendancePage.vue?vue&type=template&id=3fb58565&"
import script from "./AddLabourerAttendancePage.vue?vue&type=script&lang=js&"
export * from "./AddLabourerAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports